import {
  ListCourseLessonPlanFilters,
  listCourseLessonPlans,
} from '../services/courseLessonPlanServices';

export const courseLessonPlanQueries = {
  all: ['courseLessonPlans'] as const,

  list: (filters: ListCourseLessonPlanFilters = {}) => ({
    queryKey: [...courseLessonPlanQueries.all, 'list', { filters }] as const,
    queryFn: () => listCourseLessonPlans({ ...filters }),
  }),
};
